<script>
import searchService from "@/service/search-service"

export default {
  name: "text-highlighter",
  props: ["text", "highlight"],
  render(createElement) {
    const elements = []
    let lastIdx = 0
    for (const idx of searchService.search(this.highlight)(this.text)) {
      const normalText = this.text.substring(lastIdx, idx.start)
      const highlightText = this.text.substring(idx.start, idx.end)
      elements.push(normalText)
      elements.push(createElement("b", { class: "highlight" }, highlightText))
      lastIdx = idx.end
    }
    elements.push(this.text.substring(lastIdx))
    return createElement("span", elements)
  }
}
</script>

<style lang="scss">
.highlight {
  font-weight: bold;
  background-color: rgb(255, 223, 42);
}
</style>
